const SAME_DAY_ENQUIRIES_TITLE = 'Same Day Enquiries';

export function filterSameDayFaqSection(components, sameday) {
  if (sameday || !Array.isArray(components)) {
    return components;
  }

  const filtered = [];
  for (let i = 0; i < components.length; i += 1) {
    const component = components[i];
    if (
      component?.type === 'typography' &&
      component?.text === SAME_DAY_ENQUIRIES_TITLE
    ) {
      if (components[i + 1]?.type === 'faq') {
        i += 1;
      }
      continue;
    }
    filtered.push(component);
  }
  return filtered;
}
